import { render, staticRenderFns } from "./tnved.vue?vue&type=template&id=0de3893c&scoped=true&"
import script from "./tnved.vue?vue&type=script&lang=js&"
export * from "./tnved.vue?vue&type=script&lang=js&"
import style0 from "./tnved.vue?vue&type=style&index=0&id=0de3893c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de3893c",
  null
  
)

export default component.exports